/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_rscu_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How is RSCU calculated?`)
};

const es_rscu_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo se calcula el RSCU?`)
};

const de_rscu_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie wird RSCU berechnet?`)
};

const nl_rscu_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe wordt RSCU berekend?`)
};

const fr_rscu_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment le RSCU est-il calculé ?`)
};

const it_rscu_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come si calcola l'RSCU?`)
};

const pt_br2_rscu_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como o RSCU é calculado?`)
};

const pt_rscu_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como se calcula o RSCU?`)
};

const ja_rscu_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RSCUはどう計算されますか？`)
};

const zh_rscu_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RSCU 是如何计算的？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const rscu_faq_q2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.rscu_faq_q2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("rscu_faq_q2", locale)
	if (locale === "en") return en_rscu_faq_q2(inputs)
	if (locale === "es") return es_rscu_faq_q2(inputs)
	if (locale === "de") return de_rscu_faq_q2(inputs)
	if (locale === "nl") return nl_rscu_faq_q2(inputs)
	if (locale === "fr") return fr_rscu_faq_q2(inputs)
	if (locale === "it") return it_rscu_faq_q2(inputs)
	if (locale === "pt-BR") return pt_br2_rscu_faq_q2(inputs)
	if (locale === "pt") return pt_rscu_faq_q2(inputs)
	if (locale === "ja") return ja_rscu_faq_q2(inputs)
	return zh_rscu_faq_q2(inputs)
};